exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable[data-v-a162f9f2] {\n  width: 100%;\n}\nth[data-v-a162f9f2]{\n  border: solid 1px #e8e8e8;\n}\ntd[data-v-a162f9f2]{\n  border: solid 1px #e8e8e8;\n}\n@media screen and (max-width: 896px) {\n.table-explanation-bodytd[data-v-a162f9f2]{\n        padding: 10px;\n}\n.radio-inline__label[data-v-a162f9f2]{\n        width: 30px;\n}\n}\n@media screen and (max-width: 575px) {\n.radio-inline__label[data-v-a162f9f2] {\n        margin: 0 2px 0 0;\n}\n}\n", ""]);

// exports
